export const translationEn = {
  common: {
    previous: "Back",
    next: "Next",
    SAR: "SAR",
    yes: "Yes",
    no: "No",
  },
  "404-page": {
    title: "404",
    subTitle: "Sorry, the page you visited does not exist.",
    backHome: "Back to Home",
  },
  welcome: {
    welcomeHeading: "Get the best mortgage rates for your dream home.",
    loanFactorsTitle:
      "The max loan amount, monthly installment and rate depends on your:",
    loanFactorWorkSector: "Work sector",
    loanFactorSalary: "Salary",
    loanFactorGovernmentSupport: "Government support eligibility",
    welcomeDescription:
      "Start now to discover the financing opportunities available to you",
    termsAgreementPrefix: "I agree to the ",
    termsAgreementLink: "terms and conditions.",
    simahAgreement: "I agree to retrieve my data from SIMAH",
    startButton: "Start now",
  },
  homePurchaseQuestionnaire: {
    requiredFields: "Please answer all required questions",
    headerText:
      "We will work to find the right real estate financing for you and your needs",
    question1: "Did you find the right property?",
    question1Options: {
      yes: "Yes",
      no: "No",
    },
    question2: "What stage of the purchasing process are you in now?",
    question2OptionsYes: {
      iWouldLikeToMakeSureICanPurchase:
        "I would like to make sure I can purchase",
      iReservedTheUnit: "I reserved the unit",
    },
    question2OptionsNo: {
      iamNotThinkingAboutBuyingRightNow:
        "I am not thinking about buying right now",
      iamStillExploringOpportunitiesInTheMarket:
        "I am still exploring opportunities in the market",
    },
    question3: "How soon are you looking to buy?",
    question3Options: {
      zeroToThreeMonths: "0-3 months",
      fourToSixMonths: "4-6 months",
      sixMonthPlus: "6+ months",
      notSure: "Not sure",
    },
  },
  workQuestionnaire: {
    // Page title
    title: "Please tell us about your work",

    // Job type selection
    jobTypeRequired: "Please select a job type.",
    jobTypes: {
      government: "Government",
      military: "Military",
      privateSME: "Private (SME)",
      privateEnterprise: "Private (Enterprise)",
      retired: "Retired",
    },
    typeOfMortgageOptions: {
      readyUnit: "Ready unit",
      saleOnTheMap: "Sale on the map",
      selfBuild: "Self-build",
      other: "Other",
    },

    // Military specific fields
    militaryRank: "Rank",
    militaryRankRequired: "Please select a military rank.",
    isPilot: "Are you a pilot?",
    pilotRequired: "Please specify if you are a pilot.",

    // Common form fields
    employerName: {
      label: "Employer name",
      placeholder: "Type your name",
      required: "Please enter your employer's name.",
    },

    salary: {
      basic: {
        label: "Basic salary",
        placeholder: "Type your salary here",
        required: "Please enter your basic salary.",
      },
      net: {
        label: "Your net monthly salary after deducting insurance",
        placeholder: "Type your salary here",
        required: "Please enter your net salary.",
        info: "Monthly salary deposited in the bank account after deducting insurance",
        error: "Net salary cannot be less than basic salary.",
      },
    },

    bank: {
      label: "Salary bank",
      placeholder: "Select bank",
      required: "Please select your salary bank.",
    },

    mortgage: {
      type: {
        label: "Type of Mortgage",
        placeholder: "Select mortgage type",
        required: "Please select mortgage type",
        options: {
          readyUnit: "Ready unit",
          saleOnTheMap: "Sale on the map",
          selfBuild: "Self-build",
          other: "Other",
        },
      },
      amount: {
        label: "Mortgage amount",
        placeholder: "Enter mortgage amount",
        required: "Please enter mortgage amount",
      },
    },

    // Form validation
    pleaseAnswerAllQuestions: "Please answer all required questions",
  },
  loanQuestionnaire: {
    title: "Tell us about your financial obligations",
    question1: "Do you have any loans?",
    questionRequired: "Please answer this question",
    question1Options: {
      yes: "Yes",
      no: "No",
    },
    question1OptionsYes: {
      description:
        "What is your total monthly financial obligation (total loan installment) in Saudi Riyal and the remaining years of the obligations?",
      total: "Total",
      remaining: "Remaining years of obligations",
      sixMonths: "6 months",
      fiveYears: "5 years",
      loanType: "choose your loan type",
      loanTypeOptions: {
        mortgage: "Mortgage",
        personal: "Personal",
        car: "Car",
        // possibilty: "Possibility",
        creditCard: "Credit card",
        DBS: "Saudi Social Development",
        jisr: "Bridge",
      },
    },
    question2: "Do you currently have defaults on payments with SIMAH?",
    question2Options: {
      yes: "Yes",
      no: "No",
    },
  },
  governmentSubsidyAndEligibilitySupport: {
    fieldRequired: "Please answer all required questions",
    firstHomeTitle: "Your First Home, Tax-Free",
    royalDecree: "Royal Order No. (A/86) dated 04/18/1439 AH stipulates that",
    royalDecreeInfo:
      "The state bears the value-added tax on an amount not exceeding (one million riyals) from the purchase price of the first home for the citizen, in order to reduce the cost of owning suitable housing for citizens",
    isFirstHome: "Is this your first home?",
    yesFirstHome: "Yes, this is my first home",
    noHadHomeBefore: "No, I had a home before",
    housingSupport: "Housing Support Program Eligibility",
    supportProgramInfo:
      "The updated housing support program is one of the solutions provided to facilitate home ownership for the beneficiary through the provision of non-refundable financial support with a fixed amount of 100 or 150 thousand riyals according to the approved product matrix.",
    areYouEligible: "Are you eligible for the 'Sakani' support program?",
    yesEligible: "Yes, eligible",
    notEligible: "No, not eligible",
    notSure: "Not sure",
    isPropertyReady: "Is the property ready?",
    yes: "Yes",
    no: "No",
    back: "Back",
    calculate: "Calculate",
  },
  realEstateFinanceExpert: {
    welcome:
      "We will work on finding the right real estate financing for you and your needs.",
    yourLimit: "Your real estate finance limit is",
    currency: "SAR",
    benefitsTitle:
      "Take advantage of the Mortgage Finance Expert Service features and get the best financing offer from more than 16 financing agencies to provide:",
    benefit1: "Suitable financing amount according to your needs",
    benefit2: "Suitable monthly installment according to your budget",
    benefit3: "Special profit margin for your financing",
    additionalBenefits:
      "There are additional benefits to receiving regular updates on your financing from the Real Estate Finance Expert, as well as following up on all procedures on your behalf.",
    additionalBenefit1: "Follow up on updates for your financing first hand",
    additionalBenefit2:
      "Follow up on real estate financing procedures on your behalf until reaching real estate registration",
    additionalBenefit3:
      "Handle complete financing procedures and provide the best options for you",
    startService: "Start Service Now",
    disclaimer: "No thanks, not interested now",
  },
  paymentMethods: {
    welcome: "Welcome to Mortgage Finance Expert Service",
    serviceInfo: "We are happy to serve you with the service experience",
    serviceFee: "Service fee",
    currency: "SAR",
    includeText: "VAT",
    payNow: "Pay now to start the service and submit the request",
    selectPayment: "Choose your preferred payment method",
    applePay: "Apple Pay",
    card: "Payment Card",
    payNowButton: "Pay Now",
    cancel: "Cancel",
    error: "Error",
    processing: "Processing...",
    paymentProcessingFailed: "Payment processing failed. Please try again.",
    paymentSDKFailedToLoad:
      "Payment SDK failed to load. Please refresh the page.",
    paymentProcessedSuccessfully: "Payment processed successfully!",
    applePayError: "Apple Pay error",
    paymentCancelled: "Payment cancelled",
    paymentInitializationFailed:
      "Payment initialization failed. Please try again.",
    cardValidationFailed:
      "Card validation failed. Please check your card details.",
  },
  feedback: {
    welcome: "Welcome to Mortgage Finance Expert Service",
    title: "Thank you, payment was completed successfully  ",
    message:
      "The financial expert will contact you to provide the service during working hours from Sunday to Thursday (except for official holidays) from nine in the morning until five in the evening, maximum within 48 hours of receiving the request.",
    label: "Do you have a message or inquiry to send with your order?",
    optional: "Optional",
    placeholder: "Write your message here...",
    fieldRequired: "Please enter your message",
    submit: "Thanks, send the request",
    cancel: "Cancel",
    successMessage: "Thank you for your message!",
  },
  phoneSeller: {
    title: "Did you visit the property and are you serious about buying?",
    hint_part_1: "If you found the property, enter the seller's number.",
    hint_part_2: "And get:",
    enterSellerNumber: "If you find the property, enter the seller's number",
    andGet: "and get:",
    benefits: {
      competitiveOffers: "1- Competitive financing offers from all banks.",
      freeService:
        "1- Free service to complete the procedures at no additional cost",
      savingsUpTo: "3- Savings of up to",
      savingsAmount: "4,000 SAR",
      adminFees: "in administrative fees",
    },
    buyerMobile: {
      label: "Your Mobile Number",
      subLabel: "(Buyer)",
      placeholder: "5xxxxxxxx",
    },
    sellerMobile: {
      label: "Mobile Number Of",
      subLabel: "Real Estate Marketer Or the Property",
      placeholder: "5xxxxxxxx",
    },
    validation: {
      sellerNumberFormat: "Seller number must be 9 digits and start with 5.",
      buyerNumberFormat: "Buyer number must be 9 digits and start with 5.",
      sameNumbers: "Seller and Buyer numbers cannot be the same.",
      ownMobileNotAllowed: "Own mobile number is not allowed",
      buyerMobileNotAllowed: "Please enter a valid mobile number",
      sellerMobileNotAllowed: "Please enter a valid mobile number",
      sameMobile: "Seller and Buyer numbers cannot be the same.",
      required: "This field is required",
    },
    agreements: {
      visitedProperty: "I've visited the property and checked it",
      contactedSeller: "I've contacted the seller / broker of the property",
    },
    noProperty: {
      title: "You still haven't found a property?",
      goTo: "Go to",
      calculator: "Finance Calculator",
      andKnow: "and know your financing limit",
    },
    buttons: {
      submitRequest: "Submit Request",
      calculator: "Financing Calculator",
    },
  },
  thankYou: {
    title: "Your request has been successfully submitted!",
    message:
      "We will contact you as soon as possible to provide the best financing offers. Please prepare:",
    salaryCertificate: "1. Salary certificate",
    nationalId: "2. National ID",
    propertyDeed: "3. Property deed",
  },
  full_name: "Full name",
  mobile: "Mobile number",
  wanted_property: "Preferred real estate",
  real_state_agreement:
    "I agree to share my information with the real estate advertiser",
  real_state_share_info: "Send my information to the advertiser",
  work_sector: "In which sector do you work?",
  price: "Price",
  real_state_details_header: "Your financing limit.",
  real_state_finance_1: "Your real estate financing limit is",
  real_state_finance_2: "Your real estate",
  share_personal_info:
    "Take the initiative to share your basic information with the real estate advertiser to facilitate communication and speed up the process.",
  donot_send_info: "I don't want to send it, thank you",
  reject_header: "Thank you for using our service",
  reject_hint:
    "Thank you for using the financing calculator! Your first step toward ownership starts here",
  finance_header: "Mortgage Finance Expert Service",
  finance_benifit_from:
    "Take advantage of the benefits of the communication service with",
  real_state_expert: "real Estate Finance Expert",
  start_service_now: "Start the service now",
  edit_calculations:
    "Or, to get updated results, you can return to the financing calculator and perform a new calculation",
  re_calculate: "Return to the financing calculator",
  start_service_header:
    "✨ Benefit from a comprehensive service that starts with 💰 designing a personalized financing plan for you, in collaboration with 🤝 more than 16 financing institutions to provide:",
  start_service_header_1:
    "Welcome to the financing program design and property search service",
  // start_service_header:
  //   "✨ استفد من خدمة شاملة تبدأ بـ 💰 تصميم برنامج تمويلي مخصص لك، وتشمل 🏘️ البحث عن العقار المناسب، بالتعاون مع 🤝 أكثر من 16 جهة تمويل لتوفير:",
  start_service_para_1: "💵 A financing amount fits to your needs",
  start_service_para_2: "📆 A monthly installment that fits your budget",
  start_service_para_3:
    ":🏦 A competitive profit margin tailored to your financing",
  start_service_para_5:
    "🧭 And we’ll continue the journey with you until ownership through:",
  start_service_para_6: "🏘️ Searching for properties that suit you",
  start_service_para_7: "🤝 Supporting you in negotiating with the seller",
  start_service_para_8: "🧾 Assisting you in the ownership transfer process",
  start_service_para_9:
    "📲 Don't worry, ownership has become easier — contact us.",
  donot_start_service: "Thank you, not interested right now",
  including: "including",
  own_property: "Are you interested in owning this property?",
  payment_sccess_title: "Thank you, the payment was successful",
  payment_sucess_hint:
    "The financial expert will contact you to provide the service during working hours from Sunday to Thursday (excluding official holidays) between 9 AM and 5 PM, within a maximum of 48 hours from receiving the request",
  payment_sucess_hint_phone:
    "The financial expert will contact you on {{phone}} to provide the service during working hours from Sunday to Thursday (excluding official holidays) between 9 AM and 5 PM, within a maximum of 48 hours from receiving the request",
  success_title: "Your data has been sent successfully !",
  success_hint:
    "Your information has been sent to the real estate advertiser, and they will contact you as soon as possible",
  please_wait_while_redirecting: "Please wait ehile redirecting...",
  payment_fail_title: "Payment failed",
  onlyEnglishNumbers: "Please enter numbers using English digits only (0–9)",
  loading: "Loading...",
  first_name: "First name",
  email: "Email",
  submit: "Submit",
  required: "Required field",
  invalid_phone: "Invalid Saudi phone number (5xxxxxxxx)",
  villa: "Villa",
  apartment: "Apartment",
  land: "Land",
  other: "Other",
  floor: "Floor",
  aqar_adress: "Aqar address",
  mortgage_consultation: "Financing Calculation",
  across_banks: "(for all banks)",
  find_aqar: "Find Aqar",
  "land for sale": "Land for sale",
  "villa for sale": "Villa for sale",
  "apartment for sale": "Apartment for sale",
  "building for sale": "Building for sale",
  "home for sale": "Home for sale",
  "rest house for sale": "Rest House for sale",
  "farm for sale": "Farm for sale",
  "shop for sale": "Shop for sale",
  "floor for sale": "Floor for sale",
  send_info_confirmation:
    "Are you sure you want to share your information with the real estate advertiser to notify them of your interest?",
  confirm: "Confirm",
  no: "No",
  stc_number_connected: "The phone number registered in STC Pay",
  payWithSTC: "Pay with STC",
  loading_pay: "Loading",
  STC: "STC Pay",
  otp_code: "OTP Code",
  confirm_info_send_btn: "Share my info with the real estate advertiser",
  Financing_Consultation:
    "Financing calculation (across all banks) + detailed consultation",
  payment_header_hint: "Please select by clicking on the required service type",
  select_consultation_first: "Please select the service type first",
  third_consultation_title: "Mortgage settlement and refinancing calculation",
  payment_message:
    "In case payment has done .. yowill be contacted on this number",
  ai_consultation_title: "Financing calculation secured by your property",
  fourth_product_hint:
    "(Available only to property owners – liquidity secured by your property)",
  first_product_hint:
    "(For those who wish to obtain a new real estate financing)",
  second_product_hint:
    "(For those who wish to have an in-depth analysis based on their personal situation)",
  third_product_hint:
    "(Available only to those who already have an existing real estate financing)",
  payment_hint_phone:
    "In case payment has done .. yowill be contacted on {{phone}}",
  important_notice: "Notice",
  i_understand: "Confirm",
};
